import { gsap } from "../gsap/all.js";
import { ScrollTrigger } from "../gsap/ScrollTrigger.js";
gsap.registerPlugin(ScrollTrigger);
gsap.config({ nullTargetWarn: false });
export default {
	init() {
		// Nav

		$('.hamburger').on('click', function() {
			$(this).toggleClass('is-active');
			$('.top-bar').toggleClass('open');
			$('body').toggleClass('locked');
		});

		function addToggleAtBreakpoint() {
			if ($(window).width() <= 1024) {
				$('.menu li.parent').each(function () {
					if ($(this).find('.submenu-toggle').length === 0) {
						$(this).append('<span class="submenu-toggle"></span>');
					}
				});
			} else {
				$('.menu li.parent .submenu-toggle').remove();
			}
		}

    // Run on page load
    addToggleAtBreakpoint();

    // Run on window resize
    $(window).on('resize', function () {
    	addToggleAtBreakpoint();
    });

    $('.top-bar').on('click', '.submenu-toggle', function () {
    	$(this).toggleClass('open');
    	$(this).parent().toggleClass('sub-active');
    	$(this).prev().slideToggle();

    	if ($('.submenu-toggle').hasClass('open')) {
    		$('.top-bar').addClass('mob-overflow');
    	} else {
    		$('.top-bar').removeClass('mob-overflow');
    	}
    });

    function setVhUnit() {
    	let vh = window.innerHeight * 0.01;
    	document.documentElement.style.setProperty('--vh', `${vh}px`);
    }


    window.addEventListener('resize', setVhUnit);
    window.addEventListener('orientationchange', setVhUnit);
    document.addEventListener('DOMContentLoaded', setVhUnit);


    // Language Switch

    const wpmlMenuItems = document.querySelectorAll('.wpml-ls-menu-item.menu-item-has-children');

    wpmlMenuItems.forEach(menuItem => {
    	const toggleLink = menuItem.querySelector('a');
    	const submenu = menuItem.querySelector('.sub-menu');

    	if (!toggleLink || !submenu) return;

    	toggleLink.addEventListener('click', function (e) {
    		e.preventDefault();


    		document.querySelectorAll('.wpml-ls-menu-item .sub-menu.open').forEach(el => {
    			if (el !== submenu) {
    				el.classList.remove('open');
    			}
    		});

    		submenu.classList.toggle('open');
    	});

    	document.addEventListener('click', function (e) {
    		if (!menuItem.contains(e.target)) {
    			submenu.classList.remove('open');
    		}
    	});
    });



		// Logo Slider

		let totalSlides = 0;
		totalSlides = $(".l-slider").children().length;

		$(".l-slider").slick({
			slidesToShow: 6,
			slidesToScroll: 1,
			autoplay: totalSlides > 6,
			autoplaySpeed: 0,
			speed: 5000,
			cssEase: "linear",
			draggable: false,
			infinite: true,
			arrows: false,
			dots: false,
			responsive: [
			{
				breakpoint: 1440,
				settings: {
					slidesToShow: 4,
					autoplay: totalSlides > 4,
				},
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 2,
					autoplay: totalSlides > 2,
				},
			},
			],
		});

		$(".l-slider").on("init", function (event, slick) {
			totalSlides = slick.slideCount;
		});

		$(".l-slider").on("setPosition", function () {
			if (totalSlides > 6) {
				$(".l-slider").slick("slickPlay");
			}
		});

		$(".testimonials-slider").slick({
			dots: false,
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			speed: 500,
			cssEase: "linear",
			autoplay: false,
			autoplaySpeed: 10000,
			arrows: true,
			prevArrow: $("#testimonials-prev"),
			nextArrow: $("#testimonials-next"),
		});

		let ctaBanner = document.querySelector(".cta-form");
		let mQbanner = document.querySelector(".hero-marquee.split");
		let altDots = document.getElementById("hero-dots-alt");
		let footSmallDots = document.getElementById("dots-alt");
		let circleDotsLarge = document.getElementById("circle-dots-large");

		if (ctaBanner) {
			Dots();
		}

		if (mQbanner) {
			HeroDots();
		}

		if (altDots) {
			HeroDotsAlt();
		}

		if (footSmallDots) {
			FooterDotsAlt();
		}

		if (circleDotsLarge) {
			animateBubbles();
		}

		function Dots() {
			gsap.set("#dots path", { opacity: 0, y: 30 });
			gsap.to("#dots path", {
				opacity: 1,
				y: 0,
				duration: 1.5,
				ease: "power3.out",
				stagger: {
					each: 0.1,
					from: "random",
				},
				scrollTrigger: {
					trigger: ctaBanner,
					start: "top center",
					toggleActions: "play none none none",
				},
			});
		}

		function HeroDots() {
			gsap.set("#hero-dots path", {
				opacity: 0,
				scale: 0.8,
				transformOrigin: "center center",
			});
			gsap.to("#hero-dots path", {
				opacity: 1,
				scale: 1,
				duration: 1.5,
				ease: "power3.out",
				stagger: {
					each: 0.01,
					from: "random",
				},
				scrollTrigger: {
					trigger: "svg",
					start: "top center",
					toggleActions: "play none none none",
				},
			});
		}

		function HeroDotsAlt() {
			gsap.set("#hero-dots-alt path", {
				opacity: 0,
				scale: 0.8,
				transformOrigin: "center center",
			});
			gsap.to("#hero-dots-alt path", {
				opacity: 1,
				scale: 1,
				duration: 1.5,
				ease: "power3.out",
				stagger: {
					each: 0.01,
					from: "random",
				},
				scrollTrigger: {
					trigger: "svg",
					start: "top center",
					toggleActions: "play none none none",
				},
			});
		}

		function FooterDotsAlt() {
			gsap.set("#dots-alt path", {
				opacity: 0,
				scale: 0.8,
				transformOrigin: "center center",
			});
			gsap.to("#dots-alt path", {
				opacity: 1,
				scale: 1,
				duration: 1.5,
				ease: "power3.out",
				stagger: {
					each: 0.01,
					from: "random",
				},
				scrollTrigger: {
					trigger: "svg",
					start: "top center",
					toggleActions: "play none none none",
				},
			});
		}

		function animateBubbles({
		  bubbleSelector = ".bubble",
		  triggerElement = "#circle-dots-large",
		  start = "top 80%",
		  ease = "power2.out",       // much smoother than bounce
		  staggerEach = 0.15,        // a touch faster
		  scaleAmount = 0.85,        // smaller initial scale
		  duration = 0.8,            // quicker animation
		  opacityEmphasis = 1,        // max opacity
		} = {}) {
		  gsap.registerPlugin(ScrollTrigger);

		  const bubbles = document.querySelectorAll(bubbleSelector);
		  if (!bubbles.length) return;

		  gsap.set(bubbles, {
		    scale: scaleAmount,
		    opacity: 0,
		    transformOrigin: "center center",
		  });

		  gsap.to(bubbles, {
		    scrollTrigger: {
		      trigger: triggerElement,
		      start: start,
		      toggleActions: "play none none none",
		    },
		    scale: 1,
		    opacity: opacityEmphasis,
		    duration: duration,
		    ease: ease,
		    stagger: {
		      each: staggerEach,
		      from: "random",
		    },
		  });
		}

		function unslickCaseStudies() {
			const $slider = jQuery(
				".cases-studies-testimonial-section .cases-studies.slick-initialized"
				);
			if ($slider.length) {
				$slider.slick("unslick");
			}
		}

		function initSlickIfNeeded() {
			if (jQuery(window).width() < 768) {
				jQuery(
					".cases-studies-testimonial-section .cases-studies"
					).slick({
						slidesToShow: 1.7,
						slidesToScroll: 1,
						infinite: false,
						responsive: [
						{
							breakpoint: 470,
							settings: {
								slidesToShow: 1.2,
							},
						},
						],
					});
				}
			}

			initSlickIfNeeded();
			function FooterDotsAlt() {
				gsap.set("#dots-alt path", {
					opacity: 0,
					scale: 0.8,
					transformOrigin: "center center",
				});
				gsap.to("#dots-alt path", {
					opacity: 1,
					scale: 1,
					duration: 1.5,
					ease: "power3.out",
					stagger: {
						each: 0.01,
						from: "random",
					},
					scrollTrigger: {
						trigger: "svg",
						start: "top center",
						toggleActions: "play none none none",
					},
				});
			}

		// Sticky Widget Logic

		function initSideWidget() {
			const sideWidget = document.querySelector(".side-widget");
			const globalHeader = document.querySelector(".banner");
			const heroMarquee = document.querySelector(".hero-marquee");

			if (!sideWidget || !globalHeader) return;

			const heroHeight = heroMarquee ? heroMarquee.offsetHeight : 0;
			const totalHeight = globalHeader.offsetHeight + heroHeight;

			gsap.set(sideWidget, {
				position: "absolute",
				top: totalHeight,
				right: 0,
			});

			let isCollapsed = false;

			ScrollTrigger.create({
				trigger: sideWidget,
				start: "top +=127.5",
				end: "+=5000",
				pin: true,
				pinSpacing: false,
				anticipatePin: 1,
				onEnter: () => {
					requestAnimationFrame(() => {
						const toggle = sideWidget.querySelector(".top");
						const mid = sideWidget.querySelector(".mid");

						if (!toggle || !mid || toggle.dataset.bound) return;
						toggle.dataset.bound = "true";

						toggle.addEventListener("click", () => {
							isCollapsed = !isCollapsed;

							if (isCollapsed) {
								// COLLAPSING
								const tl = gsap.timeline();

								// Slide the whole widget to 105px
								tl.to(sideWidget, {
									x: 105, // Widget slides right
									duration: 0.4,
									ease: "power2.inOut",
								}, 0);

								// Halfway through, fade out the .mid
								tl.to(mid, {
									opacity: 0,
									duration: 0.2,
									ease: "power2.out",
									onComplete: () => {
										mid.style.visibility = "hidden";
										mid.style.pointerEvents = "none";
									},
								}, 0.2); // Starts halfway through the slide
							} else {
								// EXPANDING
								mid.style.visibility = "visible";
								mid.style.pointerEvents = "auto";

								const tl = gsap.timeline();

								// Bring back the .mid content
								tl.to(mid, {
									opacity: 1,
									duration: 0.2,
									ease: "power2.out",
								}, 0);

								// Then slide the whole widget back into place
								tl.to(sideWidget, {
									x: 0,
									duration: 0.4,
									ease: "power2.inOut",
								}, 0.1);
							}
						});
					});
				},
			});
		}

		window.addEventListener("load", initSideWidget);
		window.addEventListener("resize", () => {
			ScrollTrigger.getAll().forEach(t => t.kill());
			initSideWidget();
		});


		jQuery(window).on("resize", function () {
			unslickCaseStudies();
			initSlickIfNeeded();
		});

		// Blog Ajax Call


		var selectedCategory = '';
		var page = 2;

    // Handle Load More button click
    $('#load-more').on('click', function () {
    	var button = $(this);
    	var maxPages = button.data('max-pages');

    	console.log("Loading page:", page);

    	$.ajax({
    		type: 'POST',
    		url: ajaxurl,
    		data: {
    			action: 'load_more_customers',
    			page: page,
    			// category: selectedCategory,
    		},
    		beforeSend: function () {
    			button.text('Loading...').prop('disabled', true);
    		},
    		success: function (response) {
    			$('.stories-wrap').append(response);
    			page++;
    			button.text('Load More').prop('disabled', false);

    			Foundation.reInit($('[data-equalizer]'));

    			if (page > maxPages) {
    				button.remove();
    			}
    		},
    	});
    });

    $('.stories-cats a').on('click', function (e) {
    	e.preventDefault();

    	$(this).parent().addClass('selected').siblings().removeClass('selected');

    	selectedCategory = $(this).data('cat');

    	if (selectedCategory === 'all') {
    		page = 1;
    		selectedCategory = '';
    	}

    	$.ajax({
    		type: 'POST',
    		url: ajaxurl,
    		data: {
    			action: 'load_more_customers',
    			page: 1,
    			category: selectedCategory,
    		},
    		beforeSend: function () {
    			$('.stories-wrap').html('<p style="width: 100%; text-align: center">Loading posts...</p>');
    			$('#load-more').show().prop('disabled', true);
    		},
    		success: function (response) {
    			$('.stories-wrap').html(response);
    			$('#load-more').data('page', 1).text('Load More').prop('disabled', false);

    			Foundation.reInit($('[data-equalizer]'));

    			var maxPages = $('#load-more').data('max-pages');
    			if (page >= maxPages) {
    				$('#load-more').remove();
    			}
    		},
    	});
    });


    $('.stories-cats').on('click', function(event) {
    	$(this).toggleClass('active');
    	event.preventDefault();
    });
  },

  finalize() {},
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js